import React from "react"
import {Routes, Route} from "react-router-dom"
import {LoginCallback} from "@okta/okta-react"
import styled from "styled-components"

import {RequiredAuth} from "./RequiredAuth"
import {MetricsPage} from "./MetricsPage"

function OktaPages() {
	return (
		<Routes>
			<Route
				path="/login/callback"
				element={<LoginCallback loadingElement={<h1 id="loading-icon">Loading...</h1>} />}
			/>
			<Route path="/" element={<RequiredAuth />}>
				<Route index element={<MetricsPage />} />
			</Route>
		</Routes>
	)
}

const Style = styled.div`
	height: 100vh;
`

function Pages() {
	return (
		<Style>
			<OktaPages />
		</Style>
	)
}

export {Pages}
